import React from "react"
import PropTypes from "prop-types"

import EmptyCell from "./empty-cell"
import EventCell from "./event-cell"

const renderCells = (props) => {
  const {id, date, intervals, events, isSdAdmin, onEventClicked, onNewEvent} = props
  const cells = []
  let nextIndex = 0

  intervals.forEach(({text, peak}, index) => {
    if (index < nextIndex) return
    const event = events[text]

    if (event) {
      cells.push(<EventCell key={text} timestamp={text} event={event} isSdAdmin={isSdAdmin} onEventClicked={onEventClicked} />)
      nextIndex = index + Math.floor(event.duration / 1800)
    } else {
      cells.push(<EmptyCell fieldId={id} key={text} date={date} timestamp={text} isPeak={peak} onNewEvent={onNewEvent} />)
      nextIndex = index + 1
    }
  })

  return cells
}

const FieldTimetable = (props) => {
  return (
    <tr data-id={props.id}>
      {renderCells(props)}
    </tr>
  )
}

FieldTimetable.propTypes = {
  id: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired,
  intervals: PropTypes.array.isRequired,
  events: PropTypes.object.isRequired,
  isSdAdmin: PropTypes.bool,
  onEventClicked: PropTypes.func.isRequired,
  onNewEvent: PropTypes.func.isRequired
}

export default FieldTimetable
